// extracted by mini-css-extract-plugin
module.exports = {"results":"e_2v","resultsHidden":"e_3v"};